"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalParent = exports.ModalParentContext = void 0;
var _react = require("react");
var _cdsUtils = require("@cbhq/cds-utils");
const ModalParentContext = /*#__PURE__*/(0, _react.createContext)({
  visible: false,
  onRequestClose: _cdsUtils.noop,
  hideDividers: false,
  hideCloseButton: false
});
exports.ModalParentContext = ModalParentContext;
const useModalParent = () => (0, _react.useContext)(ModalParentContext);
exports.useModalParent = useModalParent;